// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiURL: 'https://pluton.extralum.com/extec/',
  apiModelsURL: 'https://pluton.extralum.com/extec/',
  User: 'ecom_extralum',
  KeyEncryption: 'qQetUoVVddcdMRLnDK',
  Password: 'DneVsupz3Tu3I/qQetUoVVddcdMRLnDK',
  iso: 'es',
  ProjectTitle: 'Extralum',
  EmailTypeExtralum: 1,
  EmailTypeNormal: 0,
  TokenTypeRegisterConfim: 0,
  TokenTypeChangePassword: 1,
  dataCurrency: 'currency',
  dataProject: 'project',
  dataClient: 'client',
  dataSite: 'site',
  imgDefault: '../../../assets/img/Filtro.png',
  imgPromo: '../../../assets/img/promoImg.png',
  temPass: 'AbC321xYz!',
  version: '23.04.1'
};
